// Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
export const lowerCaseSanitizer = function(text: string) {
  return text ? text.toLocaleLowerCase().trim() : '';
};
